import Link from 'next/link';

import useTranslation from '@/utils/hooks/translation/useTranslation';

// Components
import Button from '@/components/base/Button';
import Icon from '@/components/base/Icon';
import Modal from '@/components/base/Modal';

type SubscriptionCancellationModalProps = {
    isOpen: boolean;
    toggle: () => void;
    csmManagerEmail: string;
};

const SubscriptionCancellationModal = ({
    isOpen,
    toggle,
    csmManagerEmail
}: SubscriptionCancellationModalProps) => {
    const { t } = useTranslation('settings');
    return (
        <Modal data-testid="csm-cancellation-modal" open={isOpen} onDismiss={toggle}>
            <Modal.Body>
                <Modal.Title>
                    {t('subscription_invoices_page.with_csm.cancel_subscription_title')}
                </Modal.Title>
                <Modal.Content className="flex justify-center">
                    <div className="flex flex-col gap-3">
                        {csmManagerEmail ? (
                            <Link href={`mailto:${csmManagerEmail}`}>
                                <Button className="flex gap-3" data-testid="contact-csm-button">
                                    <Icon icon="envelope" />
                                    {t('subscription_invoices_page.with_csm.cancel_subscription')}
                                </Button>
                            </Link>
                        ) : null}
                        <button
                            type="button"
                            onClick={toggle}
                            className="font-GMedium text-xs text-icoGray-500 underline dark:text-icoDarkMode-wolf">
                            {t('commons:close')}
                        </button>
                    </div>
                </Modal.Content>
            </Modal.Body>
        </Modal>
    );
};

export default SubscriptionCancellationModal;
